﻿import Splide from '@splidejs/splide';

class HeroCarousel extends HTMLElement {
  connectedCallback() {
    const splide = new Splide(this, {
      type: 'loop',
      interval: 5000,
      autoplay: true,
      arrows: false,
    }).mount();
  }
}

customElements.define('hero-carousel', HeroCarousel);
